import styled from 'styled-components';
import { StyledModal } from '../../../common/shared/modal.styled';

export const StyledRefundModal = styled(StyledModal)`
    .modal-dialog {
        max-width: 600px;
    }
    .modal-dialog {
        .modal-body {
            padding: 20px;
            .info-text {
                text-align: center;
                margin-bottom: 30px;
            }
        }
    }

    .btn_12 {
        background-color: transparent;
        height: 52px;
        margin-inline-end: 0;
        margin-inline-start: 12px;
        line-height: 23px;
        width: 200px;
    }

    .bllink-button {
        width: 200px !important;
    }

    .buttons-container {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

`